import { ACTION_DEFINITIONS_V2, ACTION_STATUS_ATTACHMENTS, ACTION_STATUSES, ACTION_STATUSES_BY_ID, CUSTOMER_BY_ID, LOCATION_BY_ID, PRODUCT_MODEL_BY_ID, PRODUCT_MODELS, THING_BY_ID, THING_DEFINITION_BY_ID, THING_DEFINITIONS, TICKET_ATTACHMENTS, TICKET_BY_ID, TICKET_NOTES, TICKETS, TICKETS_V2, USER_ACTIONS_V2, USER_CUSTOMERS_V2, USER_LOCATIONS_V2, USER_THING_V2, WORK_ORDER_BY_ID, WORK_ORDERS_V2 } from "../common/endpoints";

export class OfflineStore {
    name: string;
    indexField?: string;
    getApi?: string;
    getPagedApi?: string;
    getByIdApi?: string;
    filterFields?: string[];
    crudApis?: OfflineStoreCrudApi[];
}

export class OfflineStoreCrudApi {
    method: RequestMethod;
    apiUrl: string;
    responseStatus: number;
    addCustomId?: boolean;
}

export enum RequestMethod {
    GET = 'GET',
    POST = 'POST',
    PATCH = 'PATCH',
    DELETE = 'DELETE',
}

export class OfflineRequest {
    storeName: string;
    url: string;
    method: RequestMethod;
    body: any;
    params: { [param: string]: string[] };
    headers: { [header: string]: string[] };
    id?: string; // optional id key, if missing will be automatically generated by increment
    file?: File;
}

export const OFFLINE_STORES: OfflineStore[] = [
    {
        name: 'thingDefinition',
        getApi: THING_DEFINITIONS,
        getByIdApi: THING_DEFINITION_BY_ID
    },
    {
        name: 'productModel',
        getByIdApi: PRODUCT_MODEL_BY_ID,
        getPagedApi: PRODUCT_MODELS
    },
    {
        name: 'customer',
        getByIdApi: CUSTOMER_BY_ID,
        getPagedApi: USER_CUSTOMERS_V2
    },
    {
        name: 'location',
        getByIdApi: LOCATION_BY_ID,
        getPagedApi: USER_LOCATIONS_V2
    },
    {
        name: 'thing',
        getByIdApi: THING_BY_ID,
        getPagedApi: USER_THING_V2
    },
    {
        name: 'actionDefinition',
        indexField: 'thingDefinitionId',
        getPagedApi: ACTION_DEFINITIONS_V2
    },
    {
        name: 'action',
        indexField: 'thingId',
        getByIdApi: ACTION_STATUSES_BY_ID,
        getPagedApi: USER_ACTIONS_V2,
        filterFields: ['workOrderId'],
        crudApis: [
            { method: RequestMethod.POST, apiUrl: ACTION_STATUSES, responseStatus: 200, addCustomId: true },
            { method: RequestMethod.PATCH, apiUrl: ACTION_STATUSES_BY_ID, responseStatus: 204 },
            { method: RequestMethod.DELETE, apiUrl: ACTION_STATUS_ATTACHMENTS, responseStatus: 204 },
            { method: RequestMethod.POST, apiUrl: ACTION_STATUS_ATTACHMENTS, responseStatus: 204 }
        ]
    },
    {
        name: 'historicalAction',
        indexField: 'thingId',
        getPagedApi: USER_ACTIONS_V2,
        filterFields: ['workOrderId']
    },
    {
        name: 'workOrder',
        indexField: 'thingId',
        getByIdApi: WORK_ORDER_BY_ID,
        getPagedApi: WORK_ORDERS_V2
    },
    {
        name: 'historicalWorkOrder',
        indexField: 'thingId',
        getPagedApi: WORK_ORDERS_V2
    },
    {
        name: 'ticket',
        indexField: 'thingId',
        getByIdApi: TICKET_BY_ID,
        getPagedApi: TICKETS_V2,
        crudApis: [
            { method: RequestMethod.POST, apiUrl: TICKETS, responseStatus: 201, addCustomId: true },
            { method: RequestMethod.POST, apiUrl: TICKET_NOTES, responseStatus: 204 },
            { method: RequestMethod.POST, apiUrl: TICKET_ATTACHMENTS, responseStatus: 204 }
        ]
    }
];